import React from "react";
import van_card from "../../../../../assets/img/card/teacherCard.png";
import AppURL from "../../../../../widgets/AppURL";
import { useSelector } from "react-redux";
import Barcode from "react-barcode";

const PrintTeacherIDCard = ({ filteredStudentCardList, onStudentList }) => {
  const { menu_list } = useSelector((state) => state?.software);
   const todayDate = menu_list?.np_date;
  const [year, month, day] = todayDate.split("/");
  const validDate = `${year}/12/29`;
  const Org_Details = menu_list?.structure;
  const pageCount = Math.ceil(filteredStudentCardList.length / 6);

 
  return (
    <div>
      <style>
        {`
          @media print{
            @page {
              size: A4 portrait;
              page-break-before: always;
              margin: 0.3in; 
            }
            .page-break {
              page-break-before: always;
            }
          }
        `}
      </style>

      {Array.from({ length: pageCount }).map((_, pageIndex) => (
        <div
          key={`page-${pageIndex}`}
          className="grid grid-cols-3 gap-x-1 gap-y-5 page-break"
        >
          {filteredStudentCardList
            ?.slice(pageIndex * 9, (pageIndex + 1) * 9)
            ?.map((student, index) => {
              return (
                <div key={index} className="w-[83%] border border-red-600 bg-white h-full relative">
                  <img
                    src={van_card}
                    alt="ID card background"
                    className="w-full"
                  />
                  <div className="relative px-2">
                    {/* Signature Image */}
                    <img
                      width={60}
                      src={AppURL.BaseURL + Org_Details?.head_sign}
                      alt="Signature"
                      className="mb-[-10px] ml-[34px] top-10 -rotate-30 absolute"
                    />
                    {/* Student Photo */}
                    <div className="flex justify-center">
                      <img
                        src={AppURL.BaseURL + student?.photo}
                        alt="Student"
                        className="h-16 w-16 mt-0.5 flex items-center justify-center border border-slate-300 rounded-md"
                      />
                    </div>
                    <div className="z-50">
                      <div className="flex justify-center">
                        <h3 className="text-[14px] roboto-condensed my-0.5 font-bold text-black">
                          {`${student?.first_name || ""} ${
                            student?.middle_name || ""
                          } ${student?.last_name || ""}`}
                        </h3>
                      </div>
                      <div className="mt-0.5 text-[9px]  text-slate900 px-0.5">
                        <p>
                          <strong className="text-[#1800ad]">DOB:</strong>{" "}
                          <span className="font-bold text-black">
                            {student?.dobn}
                          </span>
                        </p>
                        <p>
                          <strong className="text-[#1800ad]">
                            Designation:
                          </strong>{" "}
                          <span className="font-bold text-black">
                            {student?.designations}
                          </span>
                        </p>
                        <p>
                          <strong className="text-[#1800ad]">
                            Citizenship No.:
                          </strong>{" "}
                          <span className="font-bold text-black">
                            {student?.citiz_no}
                          </span>
                        </p>
                        <p className="capitalize">
                          <strong className="text-[#1800ad]">Address:</strong>{" "}
                          <span className="font-bold text-black">
                            {student?.per_add}
                          </span>
                        </p>

                        <p>
                          <strong className="text-[#1800ad]">Phone No:</strong>{" "}
                          <span className="font-bold text-black">
                            {student?.phone_no}
                          </span>
                        </p>
                        <p className="text-red-500">
                          <strong className="text-[#1800ad]">
                            Valid Date:
                          </strong>{" "}
                          <span className="font-bold text-black">
                            {validDate}
                          </span>
                        </p>
                        <img src="" alt="" />
                        <div className="text-red-500 -mt-8">
                          <div className="flex justify-end">
                            <img
                              width={60}
                              src={AppURL.BaseURL + Org_Details?.head_sign}
                              alt=""
                              style={{ marginBottom: "-6px" }}
                            />
                          </div>
                          <strong className="text-[#1800ad] flex justify-end">
                            Campus Chief
                          </strong>
                        </div>

                        <div className="flex -mt-2 justify-center">
                          <Barcode
                            format="CODE128"
                            displayValue={true}
                            width={1}
                            background="transparent"
                            height={30}
                            fontSize={12}
                            value={`${student?.member_sn}`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

export default PrintTeacherIDCard;
